import { render, staticRenderFns } from "./ComplianceServiceModal.vue?vue&type=template&id=1b0b0e52&scoped=true&"
import script from "./ComplianceServiceModal.vue?vue&type=script&lang=js&"
export * from "./ComplianceServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceServiceModal.vue?vue&type=style&index=0&id=1b0b0e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0b0e52",
  null
  
)

export default component.exports